<template>
  <div class="complete_surah_cont">
    <div class="row m-0">
      <div class="col-lg-2 p-0 columnAside">
        <surah-selection
          :surahNum="surahNum"
          @changeSurah="changeSurah"
        ></surah-selection>
        <div class="columnLeftSub">
          <div class="columnLeftContent">
            <div class="transCheckBoxes">
              <translation-checks></translation-checks>
            </div>
            <div class="zoomingButtons mt-2">
              <zooming-function></zooming-function>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-10 columnMain">
        <div class="columnMainContent">
          <div class="title">
            <h1 v-if="surahDetail">
              Súra {{ surahDetail.czechName }} &#160;-&#160;
              <span class="subAr" :class="$store.getters.arabicFontStyle">
                سورة {{ surahDetail.arabicName }}</span
              >
            </h1>
          </div>
          <p class="clear"></p>
          <div id="quranOutput">
            <div v-if="totalAyahs" class="card-footer">
              <base-pagination
                align="end"
                :total="totalAyahs"
                :perPage="perPage"
                :pageCount="pageCount"
                :value="page"
                @input="changePage"
              ></base-pagination>
            </div>

            <div class="key" ref="top"></div>
            <div class="verse ayahBox2" v-if="surahNum != 1 && surahNum != 9">
              <div
                class="ayah bismillah"
                :class="$store.getters.arabicFontStyle"
                style="text-align: center; direction: rtl"
              >
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="In (the) name"
                >
                  بِسْمِ</span
                >&#160;
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="(of) Allah"
                >
                  اللهِ </span
                >&#160;
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="the Most Gracious"
                >
                  الرَّحْمنِ</span
                >&#160;
                <span
                  class="bism"
                  :style="{
                    fontSize: $store.getters.customizeFontsSize + 32 + 'px',
                  }"
                  data-title="the Most Merciful"
                >
                  الرَّحِيمِ</span
                >&#160;
<!--                <span-->
<!--                  class="verse_word ayah_end"-->
<!--                  :style="{ fontSize: '40px' }"-->
<!--                  >{{ 0 | convertFormat }}</span-->
<!--                >-->
              </div>
            </div>

            <single-ayah
              v-for="(ayah, index) in surahAyahs"
              :key="index"
              :surah="surahDetail"
              :ayah="ayah"
              @scrollToTop="topUpAction"
              @changeSurah="changeSurah"
            ></single-ayah>
            <div v-if="totalAyahs" class="card-footer">
              <base-pagination
                align="end"
                :total="totalAyahs"
                :perPage="perPage"
                :pageCount="pageCount"
                :value="page"
                @input="changePage"
              ></base-pagination>
            </div>
            <!-- <div
              class="loadMore d-flex justify-content-center align-items-center pt-3 cursor_pointer"
              v-if="
                surahAyahs &&
                surahAyahs.length &&
                surahAyahs.length < totalAyahs
              "
              @click="loadMore"
            >
              Loading More...
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
import SurahSelection from "../ClientSurahViewComponents/SurahSelection";
import ZoomingFunction from "../ClientSurahViewComponents/ZoomingFunction";
import TranslationChecks from "../ClientSurahViewComponents/TranslationChecks";
import SingleAyah from "../ClientSurahViewComponents/SingleAyah";

String.prototype.toAr = function () {
  return this.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d]);
};
export default {
  components: {
    SurahSelection,
    ZoomingFunction,
    TranslationChecks,
    SingleAyah,
  },
  data() {
    return {
      surahNum: this.$route.params.surahNum,
      tempSurahNum: null,
      arabicLangId: JSON.parse(localStorage.getItem("arabicLangId")),
      languages: JSON.parse(localStorage.getItem("languages")),
      surahAyahs:
        (JSON.parse(localStorage.getItem("ayahs")) &&
          JSON.parse(localStorage.getItem("ayahs"))[this.surahNum]) ||
        [],
      surahDetail: null,

      totalAyahs: 0,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    async getSurah() {
      let getRes = await api.getSurah(this.surahNum);
      if (getRes.status == 200) {
        this.surahDetail = getRes.data.data;
      }
    },
    async getAyahs() {
      // this.$store.dispatch("toggleLoader", true);
      let query = `${this.surahNum}?page=${this.page}&perPage=${this.perPage}`;
      let getRes = await api.getAyahs(query);
      if (getRes.status == 200) {
        if (this.surahNum != this.tempSurahNum) {
          this.tempSurahNum = this.surahNum;
          this.surahAyahs = getRes.data.data.ayahs;
        } else {
          this.surahAyahs = getRes.data.data.ayahs;
          // this.surahAyahs = this.surahAyahs.concat(getRes.data.data.ayahs);
          this.topUpAction();
        }
        this.totalAyahs = getRes.data.data.total;
        let localAyahs = JSON.parse(localStorage.getItem("ayahs"));
        if (localAyahs) {
          localAyahs[this.surahNum] = this.surahAyahs;
          localStorage.setItem("ayahs", JSON.stringify(localAyahs));
        } else {
          let localAyahs = {};
          localAyahs[this.surahNum] = this.surahAyahs;
          localStorage.setItem("ayahs", JSON.stringify(localAyahs));
        }
      }
      this.$store.dispatch("toggleLoader", false);
    },

    changeSurah(surahNum) {
      this.page = 1;
      this.$router.push({ path: "/" + surahNum });
    },

    loadMore() {
      if (this.totalAyahs > this.surahAyahs.length) {
        this.page = this.page + 1;
        this.getAyahs();
      }
    },

    topUpAction() {
      var element = this.$refs["top"];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },

    scroll() {
      // window.onscroll = () => {
      //   let bottomOfWindow =
      //     Math.max(
      //       window.pageYOffset,
      //       document.documentElement.scrollTop,
      //       document.body.scrollTop
      //     ) +
      //       window.innerHeight ===
      //     document.documentElement.offsetHeight;
      //   if (bottomOfWindow) {
      //     this.loadMore();
      //   }
      // };
    },
    changePage(value) {
      // this.$store.dispatch("toggleLoader", true);
      this.page = value;
      // this.$store.dispatch("searchInQuran", object);
      this.getAyahs();
    },
  },
  computed: {
    pageCount() {
      let pageCount = this.totalAyahs / this.perPage;
      if (pageCount > 0) {
        return Math.ceil(pageCount);
      } else {
        return 0;
      }
    },
  },
  filters: {
    setLangTranslation: function (langId, ayahTranslations) {
      let translation = "";
      ayahTranslations.forEach((item) => {
        if (item.translationId == langId) {
          translation = item.translation;
        }
      });
      return translation;
    },
    convertFormat: function (number) {
      return String(number).replace(/[0-9]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1728)
      );
    },
  },
  created() {
    this.$store.dispatch("toggleLoader", true);
    this.getSurah();
    this.getAyahs();
  },
  mounted() {
    this.scroll();
    document.getElementById("search").focus();
  },
  beforeRouteUpdate(to, from, next) {
    if (this.surahNum != to.params.surahNum) {
      this.$store.dispatch("toggleLoader", true);
      this.surahNum = to.params.surahNum;
      this.getSurah();
      this.getAyahs();
      from.params.surahNum = to.params.surahNum;
      next();
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
$global_color: #4c709b;
$global_color_lit: #4c709bcc;

.complete_surah_cont {
  scroll-behavior: smooth !important;
  max-width: 1140px;
  margin: 0px auto;

  @media screen and (max-width: 1110px) and (min-width: 962px) {
    & {
      max-width: 1000px;
      overflow-x: hidden;
      padding: 0px 10px;

      .translationChecks {
        label {
          font-size: 9.5px !important;
        }
      }

      .styled-checkbox {
        & + label:before {
          width: 16px;
          height: 16px;
        }
        &:checked + label:after {
          left: 1.5px;
          top: 3px;
          // background: $global_color;
          width: 12px;
          height: 6px;
        }
      }
    }
  }
  @media screen and (max-width: 962px) {
    & {
      max-width: 920px;
      overflow-x: hidden;
    }
  }
  @media screen and (max-width: 768px) {
    & {
      max-width: auto;
      overflow-x: hidden;
      padding: 0px 10px;
      .row {
        .columnMain {
          padding-left: 0px;
        }
      }
    }
  }
}

.columnAside {
  .columnLeftSub {
    padding-bottom: 10px;

    .columnLeftContent {
      padding: 10px 10px 10px 10px;
      background-color: #fff;
      border-radius: 5px;
    }
  }
}
.columnMain {
  padding: 0px;
  padding-left: 10px;
  min-height: 82.5vh;

  .columnMainContent {
    background-color: #fff;
    padding: 5px 15px 10px 15px;
    font-size: 12px;
    line-height: 18px;
    // min-height: 481px;
    border-radius: 5px;
  }

  h1 {
    font-size: 18px;
    // color: #0099ff;
    color: $global_color;
    margin: 0px;
    font-weight: normal;
  }

  .title {
    height: 25px;
    z-index: 2;

    h1 {
      float: left;

      .subAr {
        font-size: 22px;
        font-weight: 600;
      }
    }
  }

  p.clear {
    margin: 0px;
    padding: 5px 0px 5px 0px;
  }

  #quranOutput {
    line-height: normal;
    padding-bottom: 5px;

    a,
    object {
      outline: none;
    }

    .verse {
      .ayah {
        span.bism {
          font-weight: 600;
          color: rgba(0, 0, 0, 0.9);

          &:hover {
            cursor: pointer;
            color: #0099ff !important;
            border-bottom: 2px solid #0099ff;
          }
        }
        span.ayah_end {
          position: relative;
          border: 2px solid black;
          border-radius: 100%;
          padding: 0px 15px 0px 15px;
          display: inline-block;

          &:hover {
            border-color: #0099ff;
            color: #0099ff;
            cursor: pointer;

            &:before {
              border-color: #0099ff;
            }
          }

          &:before {
            content: "";
            position: absolute;
            border: 2px solid black;
            display: block;
            width: 92%;
            height: 92%;
            border-radius: 100%;
            z-index: 1;
            left: 2.5px;
            top: 2.5px;
          }
        }
      }
    }
  }

  .giveMeEllipsis {
    white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
  }
}

#quranOutput {
  .card-footer {
    border: none !important;
    padding: 0px !important;
    background: transparent !important;

    .pagination {
      margin: 0px !important;

      .page-item {
        &:hover {
          cursor: pointer !important;
        }

        &.active {
          .page-link {
            color: rgb(45, 206, 137) !important;
            font-weight: 600;
            background-color: transparent !important;
          }
        }
      }

      .page-link {
        padding: 0px !important;
        border: none !important;
        box-shadow: none !important;
        background-color: transparent !important;

        width: 15px;
        height: 15px;
        padding: 10px;
      }

      span:hover,
      i {
        cursor: pointer !important;
      }
    }
  }
}

.loadMore {
  font-weight: 600;
  // color: #0099ff;
  color: -webkit-linear-gradient(#32b597, #b53e32) !important;
  font-size: 14px;
  font-family: system-ui;
}
</style>